import React from 'react';
import styles from './BottomCtaButtons.module.scss';
import { Button, T } from '@colonist/ui';
import { RankedModeId } from '../types.ts';
const playCtaButtonProps = {
    variant: 'cta',
    size: 'lg',
    fullWidth: true
};
/** Bottom CTA buttons for the leaderboard page */ export const BottomCtaButtons = ({ onClickBaseGame, onClick1v1, onClickCK, onClickColonistRush, activeModeId })=>{
    const ctaButtons = [
        {
            modeId: RankedModeId.Classic4P,
            labelId: 'strings:leaderboardPage.playButtons.baseGame',
            onClick: onClickBaseGame
        },
        {
            modeId: RankedModeId.Classic1v1,
            labelId: 'strings:leaderboardPage.playButtons.1v1',
            onClick: onClick1v1
        },
        {
            modeId: RankedModeId.CitiesAndKnights4P,
            labelId: 'strings:leaderboardPage.playButtons.citiesAndKnights',
            onClick: onClickCK
        },
        {
            modeId: RankedModeId.Rush4P,
            labelId: 'strings:leaderboardPage.playButtons.colonistRush',
            onClick: onClickColonistRush
        }
    ];
    const visibleButtons = activeModeId == null ? ctaButtons : ctaButtons.filter((button)=>button.modeId == activeModeId);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.bottomCtaButtonsContainer,
        "data-testid": "leaderboard-bottom-cta"
    }, visibleButtons.map((button)=>/*#__PURE__*/ React.createElement(Button, {
            key: button.modeId,
            ...playCtaButtonProps,
            onClick: button.onClick
        }, /*#__PURE__*/ React.createElement(T, {
            id: button.labelId
        }))));
};
